import { addCycleCountLines } from "./schema/add-cycle-count-lines";
import { bulkDeleteCycleCountRules } from "./schema/bulk-delete-cycle-count-rules";
import { bulkDeleteCycleCounts } from "./schema/bulk-delete-cycle-counts";
import { completeCycleCount } from "./schema/complete-cycle-count";
import { getCycleCount } from "./schema/get-cycle-count";
import {
  getCycleCountAccuracyAnalytics,
  getCycleCountApprovalsAnalytics,
  getCycleCountOverviewAnalytics,
  getCycleCountVarianceAnalytics,
} from "./schema/get-cycle-count-analytics";
import { getCycleCountRule } from "./schema/get-cycle-count-rule";
import { listCycleCountRules } from "./schema/list-cycle-count-rules";
import { listCycleCounts } from "./schema/list-cycle-counts";
import { previewAbcCycleCountRule } from "./schema/preview-abc-cycle-count-rule";
import { previewCycleCountRule } from "./schema/preview-cycle-count-rule";
import { removeCycleCountLines } from "./schema/remove-cycle-count-lines";
import { resolveCycleCountBins } from "./schema/resolve-cycle-count-bins";
import { runCycleCountRule } from "./schema/run-cycle-count-rule";
import { setCycleCountPlansEmpty } from "./schema/set-cycle-count-plans-empty";
import { setCycleCountLineCount } from "./schema/set-cycle-count-product-count";
import { getCostingMethod } from "./schema/settings/get-costing-method";
import {
  getProductGenerationRule,
  upsertProductGenerationRule,
} from "./schema/settings/product-generation-rule";
import {
  createProductTransformMapping,
  deleteProductTransformMapping,
  getProductTransformMappings,
  searchProductsForTransformMapping,
} from "./schema/settings/product-transform-mapping";
import { updateCostingMethod } from "./schema/settings/update-costing-method";
import {
  cancelCycleCount,
  deleteCycleCount,
  startCycleCount,
  updateCycleCountAssignee,
  updateCycleCountDueDate,
} from "./schema/update-cycle-count";
import { uploadCycleCountCsv } from "./schema/upload-cycle-count-csv";
import { upsertCycleCountRule } from "./schema/upsert-cycle-count-rule";

export const groupN = {
  addCycleCountLines,
  bulkDeleteCycleCountRules,
  bulkDeleteCycleCounts,
  cancelCycleCount,
  completeCycleCount,
  deleteCycleCount,
  getCycleCount,
  getCycleCountAccuracyAnalytics,
  getCycleCountApprovalsAnalytics,
  getCycleCountOverviewAnalytics,
  getCycleCountRule,
  getCycleCountVarianceAnalytics,
  listCycleCountRules,
  listCycleCounts,
  previewAbcCycleCountRule,
  previewCycleCountRule,
  getCostingMethod,
  getProductGenerationRule,
  getProductTransformMappings,
  createProductTransformMapping,
  deleteProductTransformMapping,
  searchProductsForTransformMapping,
  removeCycleCountLines,
  resolveCycleCountBins,
  runCycleCountRule,
  setCycleCountPlansEmpty,
  setCycleCountLineCount,
  uploadCycleCountCsv,
  startCycleCount,
  updateCycleCountAssignee,
  updateCycleCountDueDate,
  updateCostingMethod,
  upsertProductGenerationRule,
  upsertCycleCountRule,
};
